export default `
precision highp float;
uniform vec4 uColor;
uniform bool uShowPoint;
uniform sampler2D uSampler;

void main() {
   // check mask texture
   vec4 color = texture2D(uSampler, gl_PointCoord);
   if(color.w > 0.0 && uShowPoint){
        gl_FragColor = vec4(uColor.xyz,color.w);
   }else {
        discard ;
   }
}
`;
//# sourceMappingURL=scatterFragmentShader.js.map